var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loadingConfig === -1)?_c('Retry',{staticClass:"global-retry",attrs:{"loading":_vm.loadingConfig === true},on:{"retry":_vm.getGlobalConfig}}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }